import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotVideos from './components/HotVideos';
import Features from './components/Features';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蓝莓视频',
  url: 'https://www.lanmeishipin.com',
  description: '蓝莓视频作为特色视频平台，类似红桃视频樱花视频，提供创意热门视频，高清免费在线观看，海量剧集全集不缓冲。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.lanmeishipin.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '蓝莓视频',
  url: 'https://www.lanmeishipin.com',
  description: '高清免费在线观看特色视频平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotVideos />
        <Features />
      </main>
      <Footer />
    </>
  );
}